export default __webpack_public_path__ + "static/sc-pritchard-216faf42903ab05e6f664c004ee1d8d2.webp";